import FormItem from '@/src/components/Antd/FormItem/FormItem';
import { InputNumber as InputAntd } from 'antd';
import React, { ReactNode, useMemo } from 'react';
import { instanceType, letterFilter } from 'src/tools/helper';
import { getI18nFromGeneral } from 'src/tools/tools';
import { EnumFormItemStatus } from 'src/types/common/validation';
import css from './css.less';
import { EnumMode } from './type';
import { isNumber } from 'lodash';

export { EnumMode };
interface IProps {
  className?;
  prefix?;
  onPressEnter?;
  onChange?;
  value?;
  placeholder?;
  allowClear?;
  maxLength?;
  size?;
  autoFocus?;
  suffix?;
  error?: boolean;
  help?: string | ReactNode;
  max?: number;
  min?: number;
  customFilter?: (a: string) => string;
  fromRight?: boolean;
  hideHelper?: boolean;
  mode?: EnumMode;
  disabled?: boolean;
  suffixClassName?: string;
  onBlur?;
  wrapperClassName?: string;
  formProps?;
  precision?: number;
  inputSuffix?: string | ReactNode; //输入框后缀文字或节点
  decimalPosition?: number;
}
const suffixFontSize = {
  large: '14px',
  small: '12px',
};
const suffixTop = {
  large: '10px',
  small: '6px',
};
const Input = (props: IProps, ref) => {
  const {
    wrapperClassName,
    className,
    onChange,
    suffix,
    onPressEnter,
    value,
    placeholder,
    max,
    min,
    size,
    autoFocus,
    error,
    help,
    customFilter,
    fromRight,
    hideHelper,
    mode,
    disabled,
    formProps,
    inputSuffix,
    decimalPosition,
    ...rest
  } = props;
  const isMoney = mode === EnumMode.money;
  const isInt = mode === EnumMode.int;
  //const reg = /^\d+(\.\d{1,2})?$/;
  //console.log('props', props);

  const intLimitNumber = (value) => {
    if (typeof value === 'string') {
      return !isNaN(Number(value)) ? value.replace(/^(0{2})|[^\d]/g, '') : '';
    } else if (typeof value === 'number') {
      return !isNaN(value) ? String(value).replace(/^(0{2})|[^\d]/g, '') : '';
    } else {
      return '';
    }
  };

  const textOnchange = (e) => {
    if (onChange) {
      let value = e;
      // value = letterFilter(value);
      // console.log(value);
      if (customFilter) {
        value = customFilter(value);
      }
      if (isMoney) {
        //value = subStringNum(value, 2);
        // if (reg.test(value)) {
        //value = value.toFixed(2); //变成两位小数
        onChange(value);
        // }
      } else {
        onChange(value);
      }
    }
  };

  const convertedValue = React.useMemo(() => {
    if (value === '' || value === null || value === undefined) return '';
    if (!mode || mode === EnumMode.general) {
      return value;
    } else {
      const _v = Number(value);
      if (!!_v || _v === 0) {
        return _v;
      } else {
        return null;
      }
    }
  }, [value, mode]);

  // const limitDecimals = (value: string | number): string => {
  //   const reg = /^(\-)*(\d+)\.(\d\d).*$/;
  //   if (typeof value === 'string') {
  //     return !isNaN(Number(value)) ? value.replace(reg, '$1$2.$3') : ''; //判断需要修改
  //   } else if (typeof value === 'number') {
  //     return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : '';
  //   } else {
  //     return '';
  //   }
  // };
  return (
    <FormItem
      className={wrapperClassName}
      {...(error && {
        status: EnumFormItemStatus.error,
        help: hideHelper
          ? ''
          : help || getI18nFromGeneral('general.antd.DatePicker.item_help'),
      })}
      {...formProps}>
      <React.Fragment>
        <InputAntd
          formatter={letterFilter} //需要和别的合并处理
          {...(isMoney
            ? {
                precision: isNumber(decimalPosition) ? decimalPosition : 2, //formatter: limitDecimals, parser: limitDecimals
              }
            : {})}
          {...(isInt
            ? {
                formatter: intLimitNumber,
                parser: intLimitNumber,
              }
            : {})}
          className={`${css.inpuStyle} ${
            size === 'large' ? css.largeStyle : ''
          } ${suffix ? css.hasSuffix : ''} ${fromRight ? css.fromRight : ''} ${
            className || ''
          } `}
          onChange={textOnchange}
          ref={ref}
          autoFocus={autoFocus}
          onPressEnter={onPressEnter}
          placeholder={placeholder}
          value={convertedValue}
          size={size}
          disabled={disabled}
          max={
            instanceType(max) === 'Number'
              ? max
              : 9999999999999999999999999999999
          }
          {...(instanceType(min) === 'Number' ? { min } : { min: 0 })}
          {...rest}
        />
        {suffix && (
          <div
            className={`${css.prefixContainer} ${
              disabled ? css.disableSuffix : ''
            } `}
            style={{
              fontSize: suffixFontSize[size] || '12px',
              top: suffixTop[size] || '8px',
            }}>
            {suffix}
          </div>
        )}
        {inputSuffix}
      </React.Fragment>
    </FormItem>
  );
};

const OriNumberInput = (props) => {
  const {
    className,
    suffix,
    size,
    fromRight,
    disabled,
    value,
    mode,
    onChange,
    wrapperClassName,
    max,
    suffixClassName,
    wrapperStyle,
    ...rest
  } = props;
  //console.log(props);
  const _value = useMemo(() => {
    const v = value === null ? undefined : value;
    if (mode === EnumMode.money) {
      return !isNaN(Number(v)) ? Number(v).toFixed(4) : '';
    }
    return v;
  }, [value, mode]);

  const _onBlur = (e) => {
    const v = e.target.value;
    if (v === '' && onChange) {
      onChange();
    }
  };
  return (
    <div
      style={{ position: 'relative', flex: 1, ...(wrapperStyle || {}) }}
      className={wrapperClassName || ''}>
      <InputAntd
        formatter={letterFilter}
        className={`${css.inpuStyle} ${
          size === 'large' ? css.largeStyle : ''
        } ${suffix ? css.hasSuffix : ''} ${fromRight ? css.fromRight : ''} ${
          className || ''
        } `}
        size={size}
        disabled={disabled}
        value={_value}
        onChange={onChange}
        onBlur={_onBlur}
        max={
          instanceType(max) === 'Number' ? max : 9999999999999999999999999999999
        }
        {...rest}
      />
      {suffix && (
        <div
          className={`${css.prefixContainer} ${
            disabled ? css.disableSuffix : ''
          } ${suffixClassName || ''} `}
          style={{
            fontSize: suffixFontSize[size] || '12px',
            top: suffixTop[size] || '8px',
          }}>
          {suffix}
        </div>
      )}
    </div>
  );
};
export { OriNumberInput };

export default React.forwardRef(Input);
// export default Input;
//const NumberInputWithSuffix
